import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from "./Dropdown";
const buttonGroupVariants = cva("inline-flex w-fit items-stretch", {
    variants: {
        orientation: {
            horizontal: "flex-row",
            vertical: "flex-col",
        },
        removeGaps: {
            true: "",
            false: "gap-2",
        },
    },
    compoundVariants: [
        {
            orientation: "horizontal",
            removeGaps: true,
            className: cn("gap-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [no-css-important] — needs cleanup
            "[&>*:not(:first-child)]:rounded-l-none!", "[&>*:not(:first-child)]:border-l-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [no-css-important] — needs cleanup
            "[&>*:not(:last-child)]:rounded-r-none!"),
        },
        {
            orientation: "vertical",
            removeGaps: true,
            className: cn("gap-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [no-css-important] — needs cleanup
            "[&>*:not(:first-child)]:rounded-t-none!", "[&>*:not(:first-child)]:border-t-0", 
            // biome-ignore lint/plugin/noCssImportant: legacy [no-css-important] — needs cleanup
            "[&>*:not(:last-child)]:rounded-b-none!"),
        },
    ],
    defaultVariants: {
        orientation: "horizontal",
        removeGaps: true,
    },
});
/**
 * Groups related Buttons into a single cohesive control, laid out horizontally or
 * vertically, optionally merging their borders into a segmented control
 * (`removeGaps`). Use it for closely related actions or a split button paired with
 * ButtonGroupDropdown; for a single button with an attached chevron menu, prefer
 * SplitButton (FlexSplitButton) instead.
 * @summary Cohesive group of buttons.
 */
const ButtonGroup = React.forwardRef(({ className, orientation = "horizontal", removeGaps = true, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, role: "group", "data-orientation": orientation, className: cn(buttonGroupVariants({ orientation, removeGaps }), className), ...props }));
});
ButtonGroup.displayName = "ButtonGroup";
/**
 * A ButtonGroup child that attaches an overflow DropdownMenu to a trigger button,
 * e.g. the secondary half of a split button.
 * @summary Overflow menu for a ButtonGroup.
 */
function ButtonGroupDropdown({ trigger, items, align = "center", onOpenChange, }) {
    return (React.createElement(DropdownMenu, { onOpenChange: onOpenChange },
        React.createElement(DropdownMenuTrigger, { asChild: true }, trigger),
        React.createElement(DropdownMenuContent, { align: align }, items.map((item, index) => (React.createElement(DropdownMenuItem, { key: index, ...item }))))));
}
export { ButtonGroup, ButtonGroupDropdown, buttonGroupVariants };
//# sourceMappingURL=ButtonGroup.js.map